import { render, staticRenderFns } from "./BoardMemberList.vue?vue&type=template&id=07153254&"
import script from "./BoardMemberList.vue?vue&type=script&lang=js&"
export * from "./BoardMemberList.vue?vue&type=script&lang=js&"
import style0 from "./BoardMemberList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports